export const ConditionalWrapper = ({ condition, wrapper, children }): JSX.Element => (
  condition
    ? wrapper(children)
    : children
);
